import * as Sentry from '@sentry/react'

export function getFromSessionStorage<T>(key: string): T | undefined {
  try {
    const stringified = localStorage.getItem(key)
    if (!stringified) {
      return undefined
    }

    const item: T = JSON.parse(stringified)
    if (item) {
      return item
    }
  } catch (error) {
    Sentry.logger.error(Sentry.logger.fmt`Failed to get '${key}' from SessionStorage`, { error: String(error) })
    return undefined
  }
}

export function setInSessionStorage<T>(key: string, item: T | undefined) {
  try {
    Sentry.logger.debug(Sentry.logger.fmt`Setting LocalStorage ${key}...`)
    if (item !== undefined) {
      localStorage.setItem(key, JSON.stringify(item))
    }
    if (item === 'undefined') {
      throw new Error(`Attempting to Set Storage ${key} with string "undefined"!`)
    }
  } catch (error) {
    Sentry.logger.error(Sentry.logger.fmt`Failed to store '${key}' in SessionStorage`, { error: String(error) })
  }
}

export function deleteFromSessionStorage(key: string) {
  try {
    Sentry.logger.debug(Sentry.logger.fmt`Removing ${key} from local storage`)
    localStorage.removeItem(key)
  } catch (error) {
    Sentry.logger.error(Sentry.logger.fmt`Failed to delete '${key}' from LocalStorage`, { error: String(error) })
  }
}
